const initialState = {
  state: {},
  states: [],
  loading: false,
  error: null,
};

export const stateReducer = (state = initialState, action) => {
  switch (action.type) {
    case "ADD_STATE_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "ADD_STATE_SUCCESS":
      return {
        ...state,
        state: action.payload,
        loading: false,
        error: null,
      };
    case "ADD_STATE_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "GET_STATE_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "GET_STATE_SUCCESS":
      return {
        ...state,
        state: action.payload,
        loading: false,
        error: null,
      };
    case "GET_STATE_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "GET_STATES_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "GET_STATES_SUCCESS":
      return {
        ...state,
        states: action.payload,
        loading: false,
        error: null,
      };
    case "GET_STATES_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
